// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareMicroscopeDisconnected_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.27197 28.7283 4.68619 30.1425 10.8289 23.9998H17V21.9998H12.8289L23.765 11.0637C25.1564 12.6481 26 14.7254 26 16.9998 26 21.9703 21.9706 25.9998 17 25.9998L10 25.9998 9 27.9998 25 27.9998 24 25.9998H23.2521C26.1114 24.0091 28 20.7201 28 16.9998 28 14.1857 26.9194 11.6185 25.1555 9.67316L30.142 4.68667 28.7278 3.27246 23.6841 8.31615 22.2853 9.71434 3.27197 28.7283ZM9.7238 19.4474 15 14.1712V3.99979H9V17.9998L9.7238 19.4474ZM20.4757 8.69547 21.9518 7.21936C20.4538 6.45305 18.7629 6.01471 16.9804 6.00016V7.9998L17 7.99978C18.2321 7.99978 19.4063 8.24735 20.4757 8.69547ZM7.17139 21.9998 5.17139 23.9998H4V21.9998H7.17139Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareMicroscopeDisconnected is a generated icon component.
 */
let IconHardwareMicroscopeDisconnected = IconHardwareMicroscopeDisconnected_1 = class IconHardwareMicroscopeDisconnected extends IconBaseElement {
    render() {
        return html `${IconHardwareMicroscopeDisconnected_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareMicroscopeDisconnected.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconHardwareMicroscopeDisconnected = IconHardwareMicroscopeDisconnected_1 = __decorate([
    customElement('zui-icon-hardware-microscope-disconnected')
], IconHardwareMicroscopeDisconnected);
export { IconHardwareMicroscopeDisconnected };
